/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result

    const later = function() {
      // 据上一次触发时间间隔
      const last = +new Date() - timestamp

      // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
      if (last < wait && last > 0) {
        timeout = setTimeout(later, wait - last)
      } else {
        timeout = null
        // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
        if (!immediate) {
          result = func.apply(context, args)
          if (!timeout) context = args = null
        }
      }
    }

    return function(...args) {
      context = this
      timestamp = +new Date()
      const callNow = immediate && !timeout
      // 如果延时不存在，重新设定延时
      if (!timeout) timeout = setTimeout(later, wait)
      if (callNow) {
        result = func.apply(context, args)
        context = args = null
      }

      return result
    }
  }

/**
 * 节流
 * @param {Function} func
 * @param {number} wait
 * @return {*}
 */
export function throttle(func, wait) {
  let timeout = null;
  let lastArgs = null;
  let lastThis = null;
  let lastCallTime = 0;

  const throttled = function(...args) {
    const now = Date.now();
    const remainingTime = wait - (now - lastCallTime);

    lastArgs = args;
    lastThis = this;

    if (remainingTime <= 0 || remainingTime > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      lastCallTime = now;
      func.apply(lastThis, lastArgs);
    } else if (!timeout) {
      timeout = setTimeout(() => {
        lastCallTime = Date.now();
        timeout = null;
        func.apply(lastThis, lastArgs);
      }, remainingTime);
    }
  };

  return throttled;
}

  export function openExternal(content) {
    window.open(content)
  }

  // 替换HTML字符串中的img、audio、video、iframe的src属性为data-src
export function replaceHtmlStringSrcToDataSrc(htmlString) {
  const regex =
    /<img[^>]*src="([^"]*)"[^>]*>|<audio[^>]*src="([^"]*)"[^>]*>|<video[^>]*src="([^"]*)"[^>]*>|<iframe[^>]*src="([^"]*)"[^>]*>/gi
  return htmlString.replace(regex, match => {
    return match.replace(/src="([^"]*)"/, 'data-src="$1"')
  })
}

/**
 * 设置url的hash参数
 * @param {string} str url
 * @param {string} key 参数名
 * @param {string} value 参数值
 * @returns {string} 设置后的url
 */
export function setUrlHashParam(str, key, value) {
  const url = new URL(str)
  const hash = url.hash.slice(1)
  const hashUrl = new URLSearchParams(hash)
  if (!value && value !== 0) {
    hashUrl.delete(key)
  } else {
    hashUrl.set(key, value)
  }
  url.hash = hashUrl.toString()
  return url.toString()
}

/**
 * 获取url的hash参数
 * @param {string} str url
 * @param {string} key 参数名
 * @returns {string} 参数值
 */
export function getUrlHashParam(str, key) {
  const url = new URL(str)
  if (!url.hash) {
    return ''
  }
  const hash = url.hash.slice(1)
  const hashUrl = new URLSearchParams(hash)
  return hashUrl.get(key)
}

/**
 * 删除url的某个参数
 * @param {string} url url
 * @param {string} key 参数名
 * @returns {string} 参数值
 */
export function removePreviewParam(url, key) {
  // 1. 创建 URL 对象解析原始 URL
  const urlObj = new URL(url);
  // 2. 获取查询参数对象
  const params = new URLSearchParams(urlObj.search);
  // 3. 删除 preview 参数
  params.delete(key);
  // 4. 将新参数拼接回 URL
  urlObj.search = params.toString();
  // 5. 返回处理后的完整 URL（包含哈希）
  return urlObj.toString();
}

/**
 * 新增url的某个参数
 * @param {string} url url
 * @param {string} key 参数名
 * @returns {string} 参数值
 */
export function addEditParam(url, key, value) {
  // 1. 创建 URL 对象解析原始 URL
  const urlObj = new URL(url);
  // 2. 获取查询参数对象
  const params = new URLSearchParams(urlObj.search);
  // 3. 新增/修改参数
  params.set(key, value);
  // 4. 保留哈希（#zoom=2）并重新拼接 URL
  const hash = urlObj.hash;
  urlObj.search = params.toString();
  return urlObj.toString() + (hash ? hash : '');
}

/**
 * 获取HTML字符串中的文本
 * @param {string} val HTML字符串
 * @returns {string} 提取的纯文本
 */
export function html2Text(val) {
  const div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}